<template>
	<el-tabs v-model="activeName" @tab-click="handleClick">
		<el-tab-pane label="修改登录密码" name="first">
			<el-form ref="form" label-width="120px" size="medium">
				<el-form-item label="原登录密码">
					<el-col :span="6">
						<el-input placeholder="请填写" v-model="create_data.old_pwd" show-password clearable>
						</el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="新登录密码">
					<el-col :span="6">
						<el-input placeholder="请填写" v-model="create_data.pwd" show-password clearable>
						</el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="确认新密码">
					<el-col :span="6">
						<el-input placeholder="请填写" v-model="create_data.pwd2" show-password clearable>
						</el-input>
					</el-col>
				</el-form-item>
				<el-col :span="6" :offset="3">
					<el-button :loading="this.$store.state.ajaxLoading" @click="tj" type="primary">提交</el-button>
				</el-col>
			</el-form>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	import {
		changePwd
	} from '@/api/jd_task'
	import Qs from 'qs'
	
	export default {
		data() {
			return {
				activeName: 'first',
				create_data: {
					'old_pwd': '',
					'pwd': '',
					'pwd2': '',
				}
			};
		},
		methods: {
			handleClick(tab, event) {
				console.log(tab, event);
			},
			tj(){
				this.$store.commit('setAjaxLoading', true);
				changePwd(Qs.stringify(this.create_data)).then(response => {
					this.$message({
						showClose: true,
						message: '修改成功',
						type: 'success'
					});
					this.create_data = {
						'old_pwd': '',
						'pwd': '',
						'pwd2': '',
					}
					// location.reload();
				})
			}
		}
	};
</script>

<style>
</style>
